import React, { useState, useEffect, useCallback, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Paper, Grid, Button, Snackbar } from "@material-ui/core";
import { Menu, MenuItem } from "@material-ui/core";
import {
  Save as SaveIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  SettingsBackupRestore as RestoreIcon,
} from "@material-ui/icons";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert";
import Alert from "@material-ui/lab/Alert";
import { connect } from "react-redux";
import {
  currentRouteSet,
  createdRackSet,
  updatedRackSet,
  disableRestoreRackSet,
} from "../../actions/actions";
import { API_URL } from "../../config";
import {
  pathSpliter,
  checkAuthBranchWare,
  dateTimeFormat,
  sortRecordsNewestFirst,
} from "../../lib/functions";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
  fullWidth: {
    width: "100%",
  },
}));

const ProductRacksManage = ({
  location,
  currentRouteSet,
  authInfo,
  createdRack,
  updatedRack,
  disableRestoredRack,
  createdRackSet,
  updatedRackSet,
  disableRestoreRackSet,
}) => {
  const classes = useStyles();
  const [formValues, setFormValues] = useState({
    prod_rack_name: "",
    prod_floor_id: "",
    prod_rack_id: 0,
    action: "create",
  });
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [racks, setRacks] = useState([]);
  const [floors, setFloors] = useState([]);
  let [rackUpdateIndex, rackUpdateIndexSet] = useState("0");
  const floorRef = useRef(null)
  const rackRef = useRef(null)
  const [successMsg, setSuccessMsg] = useState({
    open: false,
    msg: "",
  });
  const [error, setError] = useState(false)

  // useEffect(() => {
  //   currentRouteSet(pathSpliter(location.pathname, 1));
  //   fetchFloors();
  //   fetchRacks();
  // }, [location.pathname, currentRouteSet]);

  // useEffect(() => {
  //   currentRouteSet(pathSpliter(location.pathname, 1));
  //   fetchFloors().then(() => {
  //     fetchRacks(); // Ensure racks are fetched only after floors
  //   });
  // }, [location.pathname, currentRouteSet]);

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    fetchFloors();
  }, [location.pathname, currentRouteSet]);

  useEffect(() => {
    if (floors.length > 0) {
      fetchRacks();
    }
  }, [floors]);

  const assignFloorName = (rack) => {
    const floor = floors.find(f => f.prod_floor_id == rack.prod_floor_id)

    return {
      ...rack,
      prod_floor_name: floor ? floor.prod_floor_name : "N/A",
    };
  }

  useEffect(() => {
    if (createdRack && checkAuthBranchWare(createdRack.user_branch_id)) {
      const completeRack = assignFloorName(createdRack.createdRow[0])
      setRacks((prevRacks) => sortRecordsNewestFirst([completeRack, ...prevRacks]));
      resetForm();
      showSuccess(createdRack.msg);
    }
  }, [createdRack]);

  useEffect(() => {
    if (updatedRack && checkAuthBranchWare(updatedRack.user_branch_id)) {
      const completeRack = assignFloorName(updatedRack.updatedRow[0])
      setRacks((prevRacks) =>
        prevRacks.map((rack, index) =>
          index === updatedRack.index ? completeRack : rack
        )
      );
      resetForm();
      showSuccess(updatedRack.msg);
    }
  }, [updatedRack]);

  useEffect(() => {
    if (
      disableRestoredRack &&
      checkAuthBranchWare(disableRestoredRack.user_branch_id)
    ) {
      const completeRack = assignFloorName(disableRestoredRack.disableRestoreRow[0])
      setRacks((prevRacks) =>
        prevRacks.map((rack, index) =>
          index === disableRestoredRack.index
            ? completeRack
            : rack
        )
      );
      showSuccess(disableRestoredRack.msg);
    }
  }, [disableRestoredRack]);

  const resetForm = () => {
    setFormValues({ prod_rack_name: "", prod_rack_id: 0, action: "create" });
  };

  const showSuccess = (msg) => {
    setSuccessMsg({ open: true, msg });
  };

  const handleClose = () => {
    setSuccessMsg({ open: false, msg: "" });
  };

  const handleFormInput = (e) => {
    const { name, value } = e.target;
    console.log(name, value)
    setFormValues((prev) => ({ ...prev, [name]: value }));
    if (rackRef.current) {
      rackRef.current.focus()
    }
  };

  const saveFormAction = async () => {
    if (formValues.prod_rack_name.trim() == "") {
      swal({
        title: "Product rack name is required",
        icon: "warning",
      });
    } else {
      formValues.rackUpdateIndex = rackUpdateIndex;
      setLoadingSave(true);
      await axios
        .post(`${API_URL}/api/rack-cu`, formValues, {
          headers: { "auth-token": authInfo.token },
        })
        .then(async (res) => {
          setLoadingSave(false);
          setError(false)
          resetForm()
          if (res?.data?.error) {
            swal({ title: res.data.message || "Failed to save rack", icon: "warning" });
            return false;
          }
          await fetchRacks();
        }).catch((error) => {
          setError(true)
          showSuccess("An Error Occured");
          resetForm()
          setLoadingSave(false)
          console.error("Rack Error:", error)
        });
    }

    if (floorRef.current) {
      floorRef.current.focus()
    }
  };

  // const fetchFloors = async () => {
  //   setLoadingList(true);
  //   try {
  //     const { data } = await axios.post(`${API_URL}/api/get-floors`, null, {
  //       headers: { "auth-token": authInfo.token },
  //     });
  //     setFloors(data.message);
  //   } catch (error) {
  //     console.error("Error fetching floors:", error);
  //   } finally {
  //     setLoadingList(false);
  //   }
  // };

  // const fetchRacks = async () => {
  //   setLoadingList(true);
  //   try {
  //     const { data } = await axios.post(`${API_URL}/api/get-racks`, null, {
  //       headers: { "auth-token": authInfo.token },
  //     });

  //     // Map racks with floor_name from floors
  //     const enrichedRacks = data.message.map((rack) => {
  //       const floor = floors.find(
  //         (floor) => floor.prod_floor_id === rack.prod_floor_id
  //       );
  //       return {
  //         ...rack,
  //         prod_floor_name: floor ? floor.prod_floor_name : "N/A",
  //       };
  //     });

  //     setRacks(enrichedRacks);
  //   } catch (error) {
  //     console.error("Error fetching racks:", error);
  //   } finally {
  //     setLoadingList(false);
  //   }
  // };

  const fetchFloors = async () => {
    setLoadingList(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/get-floors`, null, {
        headers: { "auth-token": authInfo.token },
      });
      setFloors(data.message);
    } catch (error) {
      console.error("Error fetching floors:", error);
    } finally {
      setLoadingList(false);
    }
  };

  const fetchRacks = async () => {
    setLoadingList(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/get-racks`, null, {
        headers: { "auth-token": authInfo.token },
      });

      // Map racks with floor_name from floors
      const enrichedRacks = data.message.map((rack) => {
        const floor = floors.find(
          (floor) => floor.prod_floor_id === rack.prod_floor_id
        );
        return {
          ...rack,
          prod_floor_name: floor ? floor.prod_floor_name : "N/A",
        };
      });

      setRacks(sortRecordsNewestFirst(enrichedRacks));
    } catch (error) {
      console.error("Error fetching racks:", error);
    } finally {
      setLoadingList(false);
    }
  };

  const handleAction = async (rackId, actionCond, index) => {
    if (actionCond === "disable") {
      const willContinue = await swal({
        title: "Are you sure?",
        text: "Do you want to delete this rack?",
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      });
      if (!willContinue) return;
    }

    try {
      const res = await axios.post(
        `${API_URL}/api/rack-disable-restore`,
        { prod_rack_id: rackId, action: actionCond, index },
        { headers: { "auth-token": authInfo.token } }
      );
      setError(false)
      if (res?.data?.error) {
        swal({ title: res.data.message || "Failed to update rack", icon: "warning" });
        return false;
      }
      await fetchRacks();
    } catch (error) {
      setError(true)
      showSuccess("An Error Occured")
      console.error("Error disabling/restoring rack:", error);
    }
  };

  const columns = [
    { name: "prod_rack_id", options: { display: false } },
    { name: "prod_floor_name", label: "Floor Name", options: { sort: true } },
    { name: "prod_rack_name", label: "Rack Name", options: { sort: true } },
    {
      name: "prod_rack_created_isodt",
      label: "Created Date",
      options: {
        sort: true,
        customBodyRender: (value) => moment(value).format(dateTimeFormat),
      },
    },
    {
      name: "prod_rack_updated_isodt",
      label: "Updated Date",
      options: {
        sort: true,
        customBodyRender: (value) => moment(value).format(dateTimeFormat),
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        sort: false,
        customBodyRender: (_, { rowIndex }) => {
          const rack = racks[rowIndex];
          return (
            <div>
              <EditIcon
                onClick={() => {
                  rackUpdateIndexSet(rowIndex)
                  setFormValues({ ...rack, action: "update" })
                }}
              />
              {rack.prod_rack_status === "active" ? (
                <DeleteIcon
                  onClick={() =>
                    handleAction(rack.prod_rack_id, "disable", rowIndex)
                  }
                />
              ) : (
                <RestoreIcon
                  onClick={() =>
                    handleAction(rack.prod_rack_id, "restore", rowIndex)
                  }
                />
              )}
            </div>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
  };
  return (
    <div className={classes.root}>
      <Snackbar
        open={successMsg.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={!error ? "success" : "error"}>
          {successMsg.msg}
        </Alert>
      </Snackbar>
      <Paper className={classes.paper}>
        <h2>Product Rack Entry</h2>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              inputRef={floorRef}
              label="Select Floor"
              name="prod_floor_id"
              variant="outlined"
              size="small"
              value={formValues.prod_floor_id}
              onChange={handleFormInput}
              className={classes.fullWidth}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  if (rackRef.current) {
                    rackRef.current.focus()
                  }
                }
              }}
            >
              {floors.map((floor) => (
                <MenuItem key={floor.prod_floor_id} value={floor.prod_floor_id}>
                  {floor.prod_floor_name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              inputRef={rackRef}
              label="Rack Name"
              name="prod_rack_name"
              variant="outlined"
              size="small"
              value={formValues.prod_rack_name}
              onChange={handleFormInput}
              className={classes.fullWidth}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  saveFormAction()
                }
              }}
            />
          </Grid>
        </Grid>
        <Button
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
          disabled={loadingSave}
          onClick={saveFormAction}
          className={classes.button}
        >
          Save
        </Button>
      </Paper>
      <Paper className={classes.paper}>
        {loadingList ? (
          <p>Loading...</p>
        ) : (
          <MUIDataTable
            title="Racks"
            data={racks}
            columns={columns}
            options={options}
          />
        )}
      </Paper>
    </div>
  );
};

const mapStateToProps = (state) => ({
  authInfo: state.authInfoReducer,
  createdRack: state.createdRackReducer,
  updatedRack: state.updatedRackReducer,
  disableRestoredRack: state.disableRestoreRackReducer,
});

export default connect(mapStateToProps, {
  currentRouteSet,
  createdRackSet,
  updatedRackSet,
  disableRestoreRackSet,
})(ProductRacksManage);
